import React from 'react';
import styled from 'styled-components';
import Attribution from '../../../../shared/components/Attribution';
import Columns, { Column } from '../../../../shared/components/Columns';
import DesignCard from '../../../../shared/components/DesignCard';
import { CTALink } from '../../../../shared/components/Link';
import LinkGarden from '../../../../shared/components/LinkGarden';
import { categoriesPath, categoryPath } from '../../../../shared/lib/platformUrls';
import { media } from '../../../../shared/lib/styles';
import Box from '../../../../shared/spa/core-components/Box';
import { publicImageUrl } from '../../../lib/publicImageUrl';

const CardWrapper = styled.div`
    max-width: 288px;

    @media ${media('small', 'medium', 'normal')} {
        display: none;
    }
`;

const RelatedResources = () => {
    const linkItems = [
        { label: __('Logo & brand identity pack'), url: categoryPath('brand-identity-pack') },
        { label: __('Logo & social media pack'), url: categoryPath('social-media-pack') },
        { label: __('Logo & website'), url: categoryPath('logo-website-squarespace') },
        { label: __('Logo & business card'), url: categoryPath('logo-business-card-design') },
        { label: __('Logo & brand guide'), url: categoryPath('logo-brand-guide') },
        { label: __('Business card'), url: categoryPath('business-card-design') },
        { label: __('Stationery'), url: categoryPath('stationery-design') },
        { label: __('Product packaging'), url: categoryPath('product-packaging-design') },
        { label: __('Web page design'), url: categoryPath('web-design') },
        { label: __('Book cover'), url: categoryPath('book-cover-design') },
        { label: __('T-shirt'), url: categoryPath('t-shirt-design') },
        { label: __('Product label'), url: categoryPath('product-label-design') },
    ];

    return (
        <>
            <Box marginTop="space10" marginBottom="space9">
                {__('We do more than just logos!')}
            </Box>
            <Columns>
                <Column width={[0, 0, 0, 3]}>
                    <CardWrapper>
                        <DesignCard
                            src={publicImageUrl('product-landing/build-your-brand.png')}
                            alt={__(
                                "Bottle of 'Manna' honey mead with an intricately hand drawn vintage label design by Agi Amri"
                            )}
                            width={288}
                            height={288}
                            attribution={<Attribution name="Agi Amri" />}
                            variations={['heavy-shadow']}
                        />
                    </CardWrapper>
                </Column>
                <Column width={[12, 12, 12, 9]}>
                    <Box marginBottom="space10">
                        <LinkGarden data={linkItems} columns={[1, 2, 3, 3]} />
                    </Box>
                    <Box display="flex" justifyContent="flex-end">
                        <CTALink href={categoriesPath()} color="heritage">
                            {__('See all categories')}
                        </CTALink>
                    </Box>
                </Column>
            </Columns>
        </>
    );
};

export default RelatedResources;
